import { useEffect } from "react";

interface XpAnimationProps {
  amount: number;
  onComplete: () => void;
}

export const XpAnimation = ({ amount, onComplete }: XpAnimationProps) => {
  useEffect(() => {
    const timer = setTimeout(onComplete, 1500);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="absolute inset-x-0 bottom-0 flex justify-center pointer-events-none">
      <span
        className="text-2xl font-bold text-secondary"
        style={{ animation: "floatUp 1.5s ease-out forwards" }}
      >
        +{amount} XP
      </span>
    </div>
  );
};
